var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.loading ? _c("Loading") : _vm._e(),
      _vm.isAuthenticated
        ? _c(
            "div",
            [
              _c("AppHeader"),
              _vm._m(0),
              _c("section", { staticClass: "personal-info-sc" }, [
                _c("div", { staticClass: "container" }, [
                  _c("div", { staticClass: "row justify-content-center" }, [
                    _c(
                      "div",
                      { staticClass: "col-lg-8 col-sm-12 col-xl-9 col-xs-fix" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "additonal-info-wrapper",
                            attrs: { id: "accordion" }
                          },
                          [
                            _c("form", [
                              _c("div", { staticClass: "card card-form" }, [
                                _vm._m(1),
                                _c(
                                  "div",
                                  { staticClass: "card-body compact-padding" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "compact-padding" },
                                      [
                                        _c("div", { staticClass: "form-row" }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "form-group col-md-4"
                                            },
                                            [
                                              _c(
                                                "b-form-checkbox",
                                                {
                                                  attrs: {
                                                    value: "accepted",
                                                    "unchecked-value":
                                                      "not_accepted"
                                                  },
                                                  on: {
                                                    change: function($event) {
                                                      return _vm.checkReqType(
                                                        "NEW"
                                                      )
                                                    }
                                                  },
                                                  model: {
                                                    value: _vm.reqTypeNew,
                                                    callback: function($$v) {
                                                      _vm.reqTypeNew = $$v
                                                    },
                                                    expression: "reqTypeNew"
                                                  }
                                                },
                                                [_vm._v("ออกหนังสือค้ำประกัน")]
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "form-group col-md-4"
                                            },
                                            [
                                              _c(
                                                "b-form-checkbox",
                                                {
                                                  attrs: {
                                                    value: "accepted",
                                                    "unchecked-value":
                                                      "not_accepted"
                                                  },
                                                  on: {
                                                    change: function($event) {
                                                      return _vm.checkReqType(
                                                        "EXT"
                                                      )
                                                    }
                                                  },
                                                  model: {
                                                    value: _vm.reqTypeExt,
                                                    callback: function($$v) {
                                                      _vm.reqTypeExt = $$v
                                                    },
                                                    expression: "reqTypeExt"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "ต่ออายุหนังสือค้ำประกัน"
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "form-group col-md-4"
                                            },
                                            [
                                              _c(
                                                "b-form-checkbox",
                                                {
                                                  attrs: {
                                                    value: "accepted",
                                                    "unchecked-value":
                                                      "not_accepted"
                                                  },
                                                  on: {
                                                    change: function($event) {
                                                      return _vm.checkReqType(
                                                        "INC"
                                                      )
                                                    }
                                                  },
                                                  model: {
                                                    value: _vm.reqTypeInc,
                                                    callback: function($$v) {
                                                      _vm.reqTypeInc = $$v
                                                    },
                                                    expression: "reqTypeInc"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "เพิ่มวงเงินหนังสือค้ำประกัน"
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ])
                                      ]
                                    )
                                  ]
                                ),
                                _vm._m(2),
                                _c(
                                  "div",
                                  {
                                    staticClass: "collapse show",
                                    attrs: {
                                      id: "collapseOne",
                                      "aria-labelledby": "headingOne",
                                      "data-parent": "#accordion"
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "card-body compact-padding"
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "default-padding" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "data-display mb-3"
                                              },
                                              [
                                                _c(
                                                  "table",
                                                  {
                                                    staticClass: "two-col-data"
                                                  },
                                                  [
                                                    _c("tbody", [
                                                      _c("tr", [
                                                        _c("th", [
                                                          _vm._v("Tax ID")
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "important"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.appVo
                                                                  .requesterTaxId
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]),
                                                      _c("tr", [
                                                        _c("th", [
                                                          _vm._v(
                                                            "ชื่อลูกค้า (Th)"
                                                          )
                                                        ]),
                                                        _c("td", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.appVo
                                                                .requesterNameTh
                                                            )
                                                          )
                                                        ])
                                                      ]),
                                                      _c("tr", [
                                                        _c("th", [
                                                          _vm._v(
                                                            "ชื่อลูกค้า (En)"
                                                          )
                                                        ]),
                                                        _c("td", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.appVo
                                                                .requesterNameEn
                                                            )
                                                          )
                                                        ])
                                                      ]),
                                                      _c("tr", [
                                                        _c("th", [
                                                          _vm._v(
                                                            "ที่อยู่ลูกค้า"
                                                          )
                                                        ]),
                                                        _c("td", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.appVo
                                                                .requesterAddr
                                                            ) +
                                                              "  " +
                                                              _vm._s(
                                                                _vm.appVo
                                                                  .requesterDistrict
                                                              ) +
                                                              "  " +
                                                              _vm._s(
                                                                _vm.appVo
                                                                  .requesterProvince
                                                              ) +
                                                              "  " +
                                                              _vm._s(
                                                                _vm.appVo
                                                                  .requesterZipcode
                                                              )
                                                          )
                                                        ])
                                                      ])
                                                    ])
                                                  ]
                                                )
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "form-row" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "form-group col-md-12"
                                                  },
                                                  [
                                                    _c("label", [
                                                      _vm._v(
                                                        "ผู้รับผลประโยชน์(ผู้รับหนังสือค้ำประกัน)"
                                                      )
                                                    ]),
                                                    _c(
                                                      "select",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm.beneficiary,
                                                            expression:
                                                              "beneficiary"
                                                          }
                                                        ],
                                                        ref: "input",
                                                        staticClass:
                                                          "form-control",
                                                        on: {
                                                          change: [
                                                            function($event) {
                                                              var $$selectedVal = Array.prototype.filter
                                                                .call(
                                                                  $event.target
                                                                    .options,
                                                                  function(o) {
                                                                    return o.selected
                                                                  }
                                                                )
                                                                .map(function(
                                                                  o
                                                                ) {
                                                                  var val =
                                                                    "_value" in
                                                                    o
                                                                      ? o._value
                                                                      : o.value
                                                                  return val
                                                                })
                                                              _vm.beneficiary = $event
                                                                .target.multiple
                                                                ? $$selectedVal
                                                                : $$selectedVal[0]
                                                            },
                                                            function($event) {
                                                              return _vm.getLgTypeList()
                                                            }
                                                          ]
                                                        }
                                                      },
                                                      _vm._l(
                                                        _vm.beneficiaryList,
                                                        function(option) {
                                                          return _c(
                                                            "option",
                                                            {
                                                              domProps: {
                                                                value: {
                                                                  beneTaxId:
                                                                    option.taxid,
                                                                  beneGroup:
                                                                    option.group
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                  " +
                                                                  _vm._s(
                                                                    option.nameTH
                                                                  ) +
                                                                  "\n                              "
                                                              )
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                      0
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "form-row" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "form-group col-md-12"
                                                  },
                                                  [
                                                    _c("label", [
                                                      _vm._v("ประเภทค้ำประกัน")
                                                    ]),
                                                    _c(
                                                      "select",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value: _vm.lgType,
                                                            expression: "lgType"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "form-control",
                                                        on: {
                                                          change: function(
                                                            $event
                                                          ) {
                                                            var $$selectedVal = Array.prototype.filter
                                                              .call(
                                                                $event.target
                                                                  .options,
                                                                function(o) {
                                                                  return o.selected
                                                                }
                                                              )
                                                              .map(function(o) {
                                                                var val =
                                                                  "_value" in o
                                                                    ? o._value
                                                                    : o.value
                                                                return val
                                                              })
                                                            _vm.lgType = $event
                                                              .target.multiple
                                                              ? $$selectedVal
                                                              : $$selectedVal[0]
                                                          }
                                                        }
                                                      },
                                                      _vm._l(
                                                        _vm.custLgTypeList,
                                                        function(option) {
                                                          return _c(
                                                            "option",
                                                            {
                                                              domProps: {
                                                                value:
                                                                  option.contingentId
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                  " +
                                                                  _vm._s(
                                                                    option.lgNameTh
                                                                  ) +
                                                                  "\n                              "
                                                              )
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                      0
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "form-row" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "form-group col-md-12"
                                                  },
                                                  [
                                                    _c("label", [
                                                      _vm._v(
                                                        "หมายเลขบัญชีวงเงิน"
                                                      )
                                                    ]),
                                                    _c(
                                                      "select",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm.accountNo,
                                                            expression:
                                                              "accountNo"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "form-control",
                                                        on: {
                                                          change: function(
                                                            $event
                                                          ) {
                                                            var $$selectedVal = Array.prototype.filter
                                                              .call(
                                                                $event.target
                                                                  .options,
                                                                function(o) {
                                                                  return o.selected
                                                                }
                                                              )
                                                              .map(function(o) {
                                                                var val =
                                                                  "_value" in o
                                                                    ? o._value
                                                                    : o.value
                                                                return val
                                                              })
                                                            _vm.accountNo = $event
                                                              .target.multiple
                                                              ? $$selectedVal
                                                              : $$selectedVal[0]
                                                          }
                                                        }
                                                      },
                                                      _vm._l(
                                                        _vm.commList,
                                                        function(option) {
                                                          return _c(
                                                            "option",
                                                            {
                                                              domProps: {
                                                                value:
                                                                  option.accountNo
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                  " +
                                                                  _vm._s(
                                                                    option.accountNo
                                                                  ) +
                                                                  "\n                              "
                                                              )
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                      0
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._m(3),
                                            _c(
                                              "div",
                                              { staticClass: "form-row" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "form-group col-md-6"
                                                  },
                                                  [
                                                    _c("label", [
                                                      _vm._v(
                                                        "จำนวนเงินค้ำประกัน(บาท)"
                                                      )
                                                    ]),
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value: _vm.lgAmt,
                                                          expression: "lgAmt"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "form-control",
                                                      attrs: {
                                                        type: "text",
                                                        placeholder:
                                                          "กรุณากรอกจำนวน"
                                                      },
                                                      domProps: {
                                                        value: _vm.lgAmt
                                                      },
                                                      on: {
                                                        input: function(
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          ) {
                                                            return
                                                          }
                                                          _vm.lgAmt =
                                                            $event.target.value
                                                        }
                                                      }
                                                    })
                                                  ]
                                                )
                                              ]
                                            ),
                                            _c(
                                              "keep-alive",
                                              [
                                                _c(_vm.dynamicBene, {
                                                  tag: "component"
                                                })
                                              ],
                                              1
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "form-row" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "form-group col-md-3"
                                                  },
                                                  [
                                                    _c("label", [
                                                      _vm._v(
                                                        "ระยะเวลาในการค้ำประกัน"
                                                      )
                                                    ]),
                                                    _c(
                                                      "b-form-radio",
                                                      {
                                                        attrs: { value: 1 },
                                                        model: {
                                                          value: _vm.periodType,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.periodType = $$v
                                                          },
                                                          expression:
                                                            "periodType"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "มีกำหนดระยะเวลา"
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "form-group no-label col-md-2"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                            ตั้งแต่วันที่\n                          "
                                                    )
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "form-group no-label col-md-3"
                                                  },
                                                  [
                                                    _c("date-picker", {
                                                      attrs: {
                                                        lang: "en",
                                                        format: "DD/MM/YYYY",
                                                        placeholder: ""
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.periodStartDate1,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.periodStartDate1 = $$v
                                                        },
                                                        expression:
                                                          "periodStartDate1"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "form-group no-label col-md-1"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                            ถึงวันที่\n                          "
                                                    )
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "form-group no-label col-md-3"
                                                  },
                                                  [
                                                    _c("date-picker", {
                                                      attrs: {
                                                        lang: "en",
                                                        format: "DD/MM/YYYY",
                                                        placeholder: ""
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.periodEndDate,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.periodEndDate = $$v
                                                        },
                                                        expression:
                                                          "periodEndDate"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "form-row" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "form-group no-label col-md-3"
                                                  },
                                                  [
                                                    _c(
                                                      "b-form-radio",
                                                      {
                                                        attrs: { value: 2 },
                                                        model: {
                                                          value: _vm.periodType,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.periodType = $$v
                                                          },
                                                          expression:
                                                            "periodType"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "ไม่มีกำหนดระยะเวลา"
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "form-group no-label col-md-2"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                            ตั้งแต่วันที่\n                          "
                                                    )
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "form-group no-label col-md-3"
                                                  },
                                                  [
                                                    _c("date-picker", {
                                                      attrs: {
                                                        lang: "en",
                                                        format: "DD/MM/YYYY",
                                                        placeholder: ""
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.periodStartDate2,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.periodStartDate2 = $$v
                                                        },
                                                        expression:
                                                          "periodStartDate2"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        _c("hr"),
                                        _vm._m(4),
                                        _c("hr"),
                                        _c(
                                          "div",
                                          { staticClass: "default-padding" },
                                          [
                                            _vm._m(5),
                                            _c(
                                              "div",
                                              { staticClass: "form-row" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "form-group col-md-4"
                                                  },
                                                  [
                                                    _c("label", [
                                                      _vm._v("ต้นฉบับ(บาท)")
                                                    ]),
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.majorStampAmt,
                                                          expression:
                                                            "majorStampAmt"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "form-control",
                                                      attrs: {
                                                        type: "text",
                                                        placeholder: "",
                                                        disabled: ""
                                                      },
                                                      domProps: {
                                                        value: _vm.majorStampAmt
                                                      },
                                                      on: {
                                                        input: function(
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          ) {
                                                            return
                                                          }
                                                          _vm.majorStampAmt =
                                                            $event.target.value
                                                        }
                                                      }
                                                    })
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "form-group col-md-4"
                                                  },
                                                  [
                                                    _c("label", [
                                                      _vm._v("คู่ฉบับ(บาท)")
                                                    ]),
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.minorStampAmt,
                                                          expression:
                                                            "minorStampAmt"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "form-control",
                                                      attrs: {
                                                        type: "text",
                                                        placeholder: "",
                                                        disabled: ""
                                                      },
                                                      domProps: {
                                                        value: _vm.minorStampAmt
                                                      },
                                                      on: {
                                                        input: function(
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          ) {
                                                            return
                                                          }
                                                          _vm.minorStampAmt =
                                                            $event.target.value
                                                        }
                                                      }
                                                    })
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "form-group col-md-4"
                                                  },
                                                  [
                                                    _c("label", [
                                                      _vm._v(
                                                        "จำนวนเงินเดิม(บาท)"
                                                      )
                                                    ]),
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.dutyStampAmt,
                                                          expression:
                                                            "dutyStampAmt"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "form-control",
                                                      attrs: {
                                                        type: "text",
                                                        placeholder: "",
                                                        disabled: ""
                                                      },
                                                      domProps: {
                                                        value: _vm.dutyStampAmt
                                                      },
                                                      on: {
                                                        input: function(
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          ) {
                                                            return
                                                          }
                                                          _vm.dutyStampAmt =
                                                            $event.target.value
                                                        }
                                                      }
                                                    })
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._m(6),
                                        _c("div", {
                                          staticClass: "collapse show",
                                          attrs: {
                                            id: "collapseOne",
                                            "aria-labelledby": "headingOne",
                                            "data-parent": "#accordion"
                                          }
                                        }),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "card-body compact-padding"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "default-padding"
                                              },
                                              [
                                                _c("vue-dropzone", {
                                                  ref: "myVueDropzone",
                                                  attrs: {
                                                    id: "dropzone",
                                                    options: _vm.dropzoneOptions
                                                  },
                                                  on: {
                                                    "vdropzone-removed-file":
                                                      _vm.imageRemoved
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(_vm._s(_vm.reqNo) + "\n                "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex justify-content-center mt-4"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-6 col-sm-5 col-lg-5 col-xl-4"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "cta-btn single-btn" },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-lg btn-primary-ktb",
                                              attrs: { type: "button" },
                                              on: {
                                                click: function($event) {
                                                  return _vm.saveRequest()
                                                }
                                              }
                                            },
                                            [_vm._v("บันทึก")]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ])
                          ]
                        )
                      ]
                    )
                  ])
                ])
              ]),
              _c("AppFooter")
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "section",
      { staticClass: "step-progress navbar-space no-padding" },
      [
        _c("div", { staticClass: "container step-container" }, [
          _c("div", { staticClass: "step-title" }, [
            _c("h4", [_vm._v("การขอออกหนังสือค้ำประกัน e-LG Blockchain")])
          ])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "card-header first-header card-expandable",
        attrs: {
          id: "headingOne",
          "data-toggle": "collapse",
          "data-target": "#collapseOne",
          "aria-expanded": "true",
          "aria-controls": "collapseOne"
        }
      },
      [
        _c("div", { staticClass: "title" }, [
          _c("i", { staticClass: "feather-icon icon-file-plus" }),
          _c("h5", { staticClass: "mb-0" }, [
            _vm._v("ประเภทการขอออกหนังสือค้ำประกัน")
          ])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "card-header first-header card-expandable",
        attrs: {
          id: "headingOne",
          "data-toggle": "collapse",
          "data-target": "#collapseOne",
          "aria-expanded": "true",
          "aria-controls": "collapseOne"
        }
      },
      [
        _c("div", { staticClass: "title" }, [
          _c("i", { staticClass: "feather-icon icon-file-plus" }),
          _c("h5", { staticClass: "mb-0" }, [
            _vm._v("รายละเอียดการขอค้ำประกัน")
          ])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "option-form mb-4" }, [
      _c("div", { staticClass: "form-group" }, [
        _c("label", [_vm._v("เพื่อค้ำประกันในนาม")]),
        _c("div", { staticClass: "input-group" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-secondary-custom btn-icon btn-minus",
              attrs: { type: "button" }
            },
            [_c("i", { staticClass: "feather-icon icon-minus" })]
          ),
          _c("input", {
            staticClass: "form-control",
            attrs: { type: "text", placeholder: "Tax ID" }
          }),
          _c("input", {
            staticClass: "form-control",
            attrs: { type: "text", placeholder: "ชื่อภาษาไทย" }
          }),
          _c("input", {
            staticClass: "form-control",
            attrs: { type: "text", placeholder: "ชื่อภาษาอังกฤษ" }
          }),
          _c(
            "button",
            {
              staticClass: "btn btn-secondary-custom btn-icon btn-plus",
              attrs: { type: "button" }
            },
            [_c("i", { staticClass: "feather-icon icon-plus" })]
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "default-padding" }, [
      _c("div", { staticClass: "form-row" }, [
        _c("div", { staticClass: "form-group col-md-6" }, [
          _c("label", [_vm._v("อัตราค่าธรรมเนียม(บาท)")]),
          _c("input", {
            staticClass: "form-control",
            attrs: { type: "text", placeholder: "", disabled: "" }
          })
        ])
      ]),
      _c("div", { staticClass: "form-row" }, [
        _c("div", { staticClass: "form-group col-md-6" }, [
          _c("label", [_vm._v("ตัดบัญชีค่าธรรมเนียมอัตโนมัติ")]),
          _c("input", {
            staticClass: "form-control",
            attrs: { type: "text", placeholder: "", disabled: "" }
          })
        ]),
        _c("div", { staticClass: "form-group col-md-6" }, [
          _c("label", [_vm._v("จำนวนเงินคงเหลือในบัญชี(บาท)")]),
          _c("input", {
            staticClass: "form-control",
            attrs: { type: "text", placeholder: "", disabled: "" }
          })
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-row" }, [
      _c("div", { staticClass: "form-group col-md-6" }, [
        _c("label", [_vm._v("ค่าอากรแสตมป์")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "card-header first-header card-expandable",
        attrs: {
          id: "headingOne",
          "data-toggle": "collapse",
          "data-target": "#collapseOne",
          "aria-expanded": "true",
          "aria-controls": "collapseOne"
        }
      },
      [
        _c("div", { staticClass: "title" }, [
          _c("i", { staticClass: "feather-icon icon-file-plus" }),
          _c("h5", { staticClass: "mb-0" }, [_vm._v("เอกสารประกอบเพิ่มเติม")])
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }